"use strict";

var FrameService = require("./frame-service");
module.exports = {
  create: function createFrameService(options, callback) {
    var frameService = new FrameService(options);
    frameService.initialize(function () {
      callback(frameService);
    });
  }
};